import Button from '@sportnet/ui/Button';
import {
  ContextBar,
  ContextBarItem,
  ContextBarSpacer,
} from '@sportnet/ui/ContextBar';
import Message from '@sportnet/ui/Message';
import Segment from '@sportnet/ui/Segment';
import Sidebar from '@sportnet/ui/Sidebar';
import { Table, Tbody, Td, Th, Thead, Tr } from '@sportnet/ui/Table';
import AppContext from '@sportnet/ui/TheLayout/AppContext';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Api from '../../../../Api';
import Layout from '../../../../components/Layout';
import { getProp, getStatusIcon, __ } from '../../../../utilities';
import {
  aclSelector,
  bankAccountTypeCodelistSelector,
} from '../../../App/selectors';
import { activeAppSpaceRelationsSelector } from '../../../Authorization/selectors';
import {
  bankAccountDefinition,
  codelistDefinition,
  matchDefinition,
} from '../../../FO/definitions';
import {
  fetchOrganizationBankAccounts,
  fetchOrganizationProfile,
} from '../../actions';
import {
  organizationBankAccountsListSelector,
  organizationIsFetching,
} from '../../selectors';
import Wrapper from '../index';
import BankAccountsForm from './form';

class BankAccountsList extends PureComponent {
  state = {
    sidebarVisible: false,
    bankAccount: null,
    parentProfileFetching: null,
    parentProfile: null,
    updateDisabled: true,
    createDisabled: true,
    dataNotApproved: false,
  };

  componentDidMount() {
    const { appspace } = this.props.match.params;
    this.loadOrganizationProfile();
    this.props.dispatch(fetchOrganizationBankAccounts(appspace)).then(data => {
      this.setState({ dataNotApproved: data._dataNotApproved });
    });
    this.setAclAccess(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setAclAccess(nextProps);
  }

  setAclAccess = props => {
    if (typeof this.state.disabled === 'undefined' && props.acl) {
      this.setState({
        updateDisabled: !props.acl.crmMyOrganizationRequestChange,
        createDisabled: !props.acl.crmMyOrganizationRequestChange,
      });
    }
  };

  getBankAccountType = accountTypeCode => {
    const item = this.props.bankAccountTypes.find(type => {
      return type.value === accountTypeCode;
    });
    return getProp(item, ['label']);
  };

  loadOrganizationProfile = async () => {
    const {
      match: {
        params: { appspace },
      },
      relations,
    } = this.props;
    this.setState({
      parentProfileFetching: true,
    });
    const organization = await this.props.dispatch(
      fetchOrganizationProfile(appspace),
    );
    const state = {
      parentProfileFetching: false,
    };
    if (organization) {
      state.orgLogoSrc = organization.logo_public_url || null;
      state.orgFaviconSrc = organization.favicon_public_url || null;
    }
    if (relations.length) {
      try {
        const parentProfile = await Api.organizationPPOProfile(
          relations[0].related_ppo,
        );
        if (parentProfile) {
          state.parentProfile = parentProfile;
        }
      } catch (e) {
        //
      }
    }
    this.setState(state);
  };

  render() {
    const { bankAccounts, isFetching } = this.props;
    const { bankAccount, sidebarVisible, parentProfileFetching } = this.state;
    return (
      <Layout
        bottomFixed={
          !this.state.createDisabled && (
            <ContextBar>
              <ContextBarSpacer />
              <ContextBarItem>
                <Button
                  onClick={() => {
                    this.setState({
                      sidebarVisible: true,
                    });
                  }}
                  primary
                >
                  {__('Pridať záznam')}
                </Button>
              </ContextBarItem>
            </ContextBar>
          )
        }
      >
        <AppContext title={__('Moja organizácia')} />
        <Wrapper
          isFetching={isFetching || parentProfileFetching}
          activeTab={__('Bankové účty')}
        >
          {!this.state.createDisabled && this.state.parentProfile && (
            <Message
              warning
              title={__('Zmeny podliehajú schvaľovaciemu procesu')}
            >
              {`${__(
                'Pridaním alebo odstránením účtu sa zmeny zašlú na schválenie organizácii',
              )} ${this.state.parentProfile.name}`}
            </Message>
          )}
          {this.state.dataNotApproved === true && this.state.parentProfile && (
            <Message danger title={__('Údaje čakajú na schválenie')}>
              {`${__('Zmeny boli odoslané na schválenie organizácii')} ${
                this.state.parentProfile.name
              }`}
            </Message>
          )}
          <Segment raised>
            <Table>
              <Thead>
                <Tr>
                  <Th>{__('Typ')}</Th>
                  <Th>{__('IBAN')}</Th>
                  <Th>{__('Stav')}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {bankAccounts.map(account => {
                  return (
                    <Tr
                      key={account._id}
                      {...(!this.state.updateDisabled && {
                        onClick: () => {
                          this.setState({
                            sidebarVisible: true,
                            bankAccount: account,
                          });
                        },
                      })}
                    >
                      <Td>{this.getBankAccountType(account.type)}</Td>
                      <Td>{account.IBAN}</Td>
                      <Td>{getStatusIcon(account.status)}</Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </Segment>
        </Wrapper>
        <Sidebar
          onClose={() => {
            this.setState({ sidebarVisible: false, bankAccount: null });
          }}
          visible={sidebarVisible}
          header={__('Bankový účet')}
        >
          {sidebarVisible && (
            <BankAccountsForm
              closeSidebar={() => {
                this.setState({ sidebarVisible: false, bankAccount: null });
              }}
              parameters={{ bankAccount }}
            />
          )}
        </Sidebar>
      </Layout>
    );
  }
}

BankAccountsList.propTypes = {
  bankAccounts: PropTypes.arrayOf(bankAccountDefinition).isRequired,
  bankAccountTypes: PropTypes.arrayOf(codelistDefinition).isRequired,
  dispatch: PropTypes.func.isRequired,
  match: matchDefinition.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
  return {
    bankAccountTypes: bankAccountTypeCodelistSelector(state),
    bankAccounts: organizationBankAccountsListSelector(state),
    isFetching: organizationIsFetching(state),
    relations: activeAppSpaceRelationsSelector(state),
    acl: aclSelector(state),
  };
};

export default connect(mapStateToProps)(BankAccountsList);
